export default "__VITE_ASSET__DGMc7dkG__"